class CurrencyDecimalReplacer {
  constructor(config = {}) {
    const { currencySelectors } = config;

    // Handle multiple selectors as a single string (comma-separated) or as an array
    const selector = Array.isArray(currencySelectors)
      ? currencySelectors.join(', ')
      : currencySelectors;

    // Query all matching elements
    this.currencySpans = document.querySelectorAll(selector);
    this.currencySpansArray = Array.prototype.slice.call(this.currencySpans);

    if (this.currencySpans.length > 0) {
      this.replaceDecimal();
    }
  }

  replaceDecimal() {
    this.currencySpansArray.forEach((e) => {
      let text = e.textContent;
      e.textContent = text.replace(/,/g, '.');
    });
  }
}

export default CurrencyDecimalReplacer;
